import { Phone, Mail, MessageCircle, MapPin, Clock } from "lucide-react";
import ContactForm from "@/components/ContactForm";
import { CONTACT } from "@/data/content";

export default function ContactPage() {
  return (
    <div data-testid="contact-page" className="bg-white">
      <section className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-14">
            <p className="text-sm font-semibold text-green-600 uppercase tracking-wider mb-3">Contact</p>
            <h1 className="font-heading text-4xl sm:text-5xl font-bold tracking-tight text-slate-900">
              Discutons de votre visibilité
            </h1>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">
              Remplissez le formulaire ou contactez-nous directement. Réponse rapide garantie.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
            <div className="space-y-3">
              <a href={`tel:${CONTACT.phoneRaw}`} data-testid="page-contact-call" className="flex items-center gap-3 rounded-xl border border-slate-200 hover:border-green-600 p-4 transition-colors">
                <span className="h-12 w-12 rounded-xl bg-green-50 text-green-600 flex items-center justify-center"><Phone size={22} /></span>
                <span><span className="block text-sm text-slate-500">Appelez-nous</span><span className="font-semibold text-slate-900 text-lg">{CONTACT.phone}</span></span>
              </a>
              <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noreferrer" data-testid="page-contact-whatsapp" className="flex items-center gap-3 rounded-xl border border-slate-200 hover:border-green-600 p-4 transition-colors">
                <span className="h-12 w-12 rounded-xl bg-green-50 text-green-600 flex items-center justify-center"><MessageCircle size={22} /></span>
                <span><span className="block text-sm text-slate-500">WhatsApp</span><span className="font-semibold text-slate-900 text-lg">Discuter maintenant</span></span>
              </a>
              <a href={`mailto:${CONTACT.email}`} data-testid="page-contact-email" className="flex items-center gap-3 rounded-xl border border-slate-200 hover:border-green-600 p-4 transition-colors">
                <span className="h-12 w-12 rounded-xl bg-green-50 text-green-600 flex items-center justify-center"><Mail size={22} /></span>
                <span><span className="block text-sm text-slate-500">Email</span><span className="font-semibold text-slate-900 break-all">{CONTACT.email}</span></span>
              </a>
              <div className="flex items-center gap-3 rounded-xl bg-slate-50 p-4">
                <span className="h-12 w-12 rounded-xl bg-slate-900 text-green-400 flex items-center justify-center"><MapPin size={22} /></span>
                <span><span className="block text-sm text-slate-500">Zone d'intervention</span><span className="font-semibold text-slate-900">{CONTACT.zoneText}</span></span>
              </div>
              <div className="flex items-center gap-3 rounded-xl bg-slate-50 p-4">
                <span className="h-12 w-12 rounded-xl bg-slate-900 text-green-400 flex items-center justify-center"><Clock size={22} /></span>
                <span><span className="block text-sm text-slate-500">Disponibilité</span><span className="font-semibold text-slate-900">7j/7</span></span>
              </div>
            </div>

            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
}
